import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Button } from '@pwc/pwc-deals-ui';
import './ModalConfirmation.scss';

/**
 * @deprecated Use instead: src/common/components/ModalConfirmation/ModalConfirmation.tsx
 */

const ModalConfirmation = ({
  show = false,
  onCancel,
  onConfirm,
  confirmTitle = 'Proceed?',
  confirmationMessage = 'Are you sure?',
  cancelButtonText,
  confirmButtonText = 'Proceed',
  showCancel = true,
  disabledConfirm = false,
  centered = false,
  dialogClassName = '',
  contentClassName = '',
}) => {
  const [buttonPressed, setButtonPressed] = useState(false);
  const { t } = useTranslation();
  const handleConfirm = () => {
    onConfirm();
    setButtonPressed(true);
  };

  useEffect(() => {
    setButtonPressed(false);
  }, [show]);

  cancelButtonText = cancelButtonText || t('cancel');
  return (
    <Modal
      show={show}
      onHide={onCancel}
      centered={centered}
      dialogClassName={dialogClassName}
      contentClassName={contentClassName}
    >
      <Modal.Header closeButton>
        <Modal.Title>{confirmTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{confirmationMessage}</Modal.Body>
      <Modal.Footer>
        {showCancel && (
          <Button
            className="button-link mr-3"
            data-testid="modal-cancel"
            onClick={onCancel}
          >
            {cancelButtonText}
          </Button>
        )}
        <Button
          data-testid="modal-confirm"
          onClick={handleConfirm}
          disabled={disabledConfirm || buttonPressed}
        >
          {confirmButtonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalConfirmation;
